import gql from "graphql-tag";

export const CREATE_AUTHORIZATION_BY_EXAMINER = gql`
  mutation createAuthorizationByExaminer($contractCode: String!) {
    createAuthorizationByExaminer(contractCode: $contractCode)
  }
`;
